import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fromJS } from 'immutable';
import { reduxForm, Field, Form, submit } from 'redux-form/immutable';
import {
  TextField,
} from 'redux-form-material-ui';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FlatButton from 'material-ui/FlatButton';
import Chip from 'material-ui/Chip';
import _ from 'lodash';

import { showDialog, hideDialog, isDialogOpen } from '../../actions/dialogs';
import {
  fetchEmployee,
  setEmployee,
  setImage,
  addTag,
  removeTag,
  addPermission,
  removePermission,
} from '../../actions/employees';
import ImageUpload from '../Common/ImageUpload';
import AssignPermissionDialog from '../AssignPermissionDialog';
import ReduxDialog from '../Common/ReduxDialog';
import { saveEmployeeRoutine } from '../../routines';
import { splitCamelCase, validateMobile, validateEmail, toArray } from '../../utils/helper';

import FireBaseTools, { firebaseStorage, getTenantPath } from '../../utils/firebase';

import commonStyles from '../styles';
import styles from './styles';

const validate = (values, props) => {
  const valuesObj = values.toJS();
  const errors = {};
  const requiredFields = ['firstName', 'lastName', 'mobile', 'email'];
  requiredFields.forEach((field) => {
    if (!valuesObj[field]) {
      errors[field] = `Require a ${splitCamelCase(field)} field`;
    }
  });

  if ((valuesObj.firstName && valuesObj.lastName) || valuesObj.email) {
    props.employees.forEach((employee) => {
      if (employee.id !== valuesObj.id) { // ignore self
        if (employee.email === valuesObj.email) {
          errors.email = 'Email already exist';
        }

        if (employee.mobile === valuesObj.mobile) {
          errors.mobile = 'Mobile already exist';
        }
      }
    });
  }
  if (valuesObj.mobile && !validateMobile(valuesObj.mobile)) {
    errors.mobile = 'Only Numeric Characters';
  }
  if (valuesObj.email && !validateEmail(valuesObj.email)) {
    errors.email = 'Invalid email address';
  }
  return errors;
};

const renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => {
  return (
    <TextField
      hintText={label}
      floatingLabelText={label}
      errorText={touched && error}
      {...input}
      {...custom}
    />);
}

class Employee extends Component {
  static propTypes = {
    fetchEmployee: PropTypes.func.isRequired,
    setEmployee: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    employee: PropTypes.object.isRequired,

    setImage: PropTypes.func.isRequired,
    addPermission: PropTypes.func.isRequired,
    removePermission: PropTypes.func.isRequired,

    addTag: PropTypes.func.isRequired,
    removeTag: PropTypes.func.isRequired,

    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,

    showAssignPermission: PropTypes.bool.isRequired,
    showTag: PropTypes.bool.isRequired,

    submit: PropTypes.func.isRequired,
  };

  state = {
    dialogs: {
      tag: false,
    },
  };

  componentWillMount() {
    if (this.props.employee && this.props.employee.image) {
      firebaseStorage.ref(getTenantPath(`/employees/${this.props.employee.image}`)).getDownloadURL().then((image) => {
          this.setState({
            image,
          });
        }
      );
    }
  }

  handleAddTag = () => {
    this.props.showDialog('tag', {
      onRequestClose: (tag) => {
        this.props.hideDialog('tag');
        if (tag) {
          this.props.addTag(this.props.employee, tag);
        }
      },
    });
  }

  handleRequestCloseAssignPermission = (permission) => {
    console.log('handleRequestCloseAssignPermission', permission);
    this.props.hideDialog('assignPermission');
    if (permission) {
      this.props.addPermission(this.props.employee, permission);
    }
  };

  handleRequestRemovePermission(permission) {
    this.props.removePermission(this.props.employee, permission);
  }

  handleRequestRemoveTag(tag) {
    this.props.removeTag(this.props.employee, tag);
  }

  handleDiscard = () => {
    this.props.hideDialog('employee');
  };

  handleImageUpload = (image, data) => {
    console.log('handleImageUpload', image, data);
    FireBaseTools.uploadEmployeeImage(image, data);
    this.props.setImage(this.props.employee, image);
  };

  renderTags(tags = []) {
    return (<div style={commonStyles.row}>
      { tags.map(this.renderTag) }
    </div>);
  }

  renderTag = (tag) => (<Chip
    key={tag}
    onRequestDelete={() => this.handleRequestRemoveTag(tag)}
    style={styles.chip}
  >{tag}</Chip>);

  renderPermissions(permissions) {
    return (<div style={styles.permissionRow}>
      { permissions.map(this.renderPermission) }
    </div>);
  }

  renderPermission = (permission) => (<Chip
    key={permission}
    onRequestDelete={() => this.handleRequestRemovePermission(permission)}
    style={styles.chip}
  >{permission}</Chip>);

  render() {
    const { handleSubmit, employee } = this.props;

    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={this.handleDiscard}
      />,
      <FlatButton
        label="Save"
        primary
        onClick={() => this.props.submit()}
      />,
    ];
    //
    const permissions = employee.permissions ? _.keys(employee.permissions) : [];
    return (
      <ReduxDialog
        title={employee && employee.id ? employee.name : 'Add Employee'}
        actions={actions}
        modal={false}
        name="employee"
        onRequestClose={this.handleDiscard}
        autoScrollBodyContent
        bodyStyle={styles.body}
      >
        <Form onSubmit={handleSubmit}>
          <div style={styles.row}>
            <div style={styles.profile}>
              <ImageUpload
                type="employee"
                src={this.state.image}
                height={300}
                width={300}
                onUpload={this.handleImageUpload}/>
            </div>
            <div style={styles.main}>
              <div style={styles.row}>
                <Field
                  name="firstName"
                  component={renderTextField}
                  floatingLabelText="First Name"
                  floatingLabelFixed
                  fullWidth
                  style={commonStyles.input}
                />
                <Field
                  name="lastName"
                  component={renderTextField}
                  floatingLabelText="Last Name"
                  floatingLabelFixed
                  fullWidth
                  style={commonStyles.input}
                />
              </div>
              <div style={styles.row}>
                <Field
                  name="mobile"
                  component={renderTextField}
                  floatingLabelText="Mobile"
                  floatingLabelFixed
                  fullWidth
                  style={commonStyles.input}
                />
                <Field
                  name="email"
                  component={renderTextField}
                  floatingLabelText="Email"
                  floatingLabelFixed
                  fullWidth
                  style={commonStyles.input}
                  disabled={_.isString(employee.id)}
                />
              </div>
              <div>
                <div style={styles.permissionHeader}>
                  <label style={styles.permissionLabel}>Permissions</label>
                  <FloatingActionButton
                    style={styles.addItem} mini secondary
                    onClick={() => this.props.showDialog('assignPermission')}
                  >
                    <ContentAdd />
                  </FloatingActionButton>
                </div>
                { this.renderPermissions(permissions) }

              </div>
            </div>
          </div>
          <div>
            <div style={styles.tagsHeader}>
              <label style={styles.tagsLabel}>Tags</label>
              <FloatingActionButton
                style={styles.addItem} mini secondary
                onClick={this.handleAddTag}
              >
                <ContentAdd />
              </FloatingActionButton>
            </div>
            { this.renderTags(employee.tags) }
          </div>
        </Form>
        { this.props.showAssignPermission ?
          <AssignPermissionDialog onRequestClose={this.handleRequestCloseAssignPermission}/> : null }
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'employee',  // a unique identifier for this form
  validate,
  onSubmit: (values, dispatch, props) => {
    const employee = values
      .setIn(['name'], `${values.get('firstName')} ${values.get('lastName')}`)
      .setIn(['permissions'], fromJS(props.employee.permissions || []))
      .setIn(['tags'], fromJS(props.employee.tags || []));
    console.log('onSubmit', employee);
    return dispatch(saveEmployeeRoutine.trigger(employee));
  },
  onSubmitSuccess: (result, dispatch, props) => {
    console.log('onSubmitSuccess');
    props.hideDialog('employee');
  },
})(Employee);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchEmployee,
    setEmployee,
    setImage,
    addPermission,
    removePermission,
    addTag,
    removeTag,

    showDialog,
    hideDialog,

    // save: () => dispatch(submit('employee')),
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    permissions: toArray(state.get('static').get('permissions').toJS()),
    employees: state.get('employees').get('employees').toJS(),
    // currentUser: state.get('authentication').get('user'),
    employee: state.get('employees').get('employee').toJS(),
    loading: state.get('employees').get('loading'),
    initialValues: state.get('employees').get('employee').toJS(),

    showAssignPermission: isDialogOpen(state.get('dialogs').get('dialogs').toJS(), 'assignPermission'),
    showTag: isDialogOpen(state.get('dialogs').get('dialogs').toJS(), 'tag'),

    submit: () => this.props.dispatch(submit('employee')),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Employee/index.js